module.exports = __webpack_public_path__ + "static/media/galeria_elo_16.50dd22d3.jpg";